import React from "react";
import { Moon, Sun } from "lucide-react";

export default function ThemeToggle() {
  const [dark, setDark] = React.useState(() => {
    return localStorage.getItem("theme") === "dark";
  });

  React.useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <button
      type="button"
      onClick={() => setDark((v) => !v)}
      className="relative inline-flex h-8 w-14 items-center rounded-full bg-[#EAE3D9] dark:bg-[#2D2A26] transition-colors"
      title="Cambia tema"
    >
      <span
        className={`inline-flex h-6 w-6 items-center justify-center rounded-full bg-white shadow transition-transform ${
          dark ? "translate-x-7" : "translate-x-1"
        }`}
      >
        {dark ? (
          <Moon size={14} className="text-[#2D2A26]" />
        ) : (
          <Sun size={14} className="text-[#C8553D]" />
        )}
      </span>
    </button>
  );
}
